import { faCheckSquare, faEye, faTimesSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import If from "components/common/If";
import Button from "components/common/button/Button";
import { useState } from "react";
import { Roles } from "utilities/app-utilities";
import useAppContext from "utilities/hooks/useAppContext";

type EventDatalistActionsProps = {
    item: {
        id: number;
        isDone: boolean;
    },
    viewModalId: string;
    onChangeIsDone: (id: number, isDone: boolean) => Promise<void>;
}

const EventDatalistActions = (props: EventDatalistActionsProps) => {
    const context = useAppContext();
    const [disabled, setDisabled] = useState(false);
    const item = props.item;

    const onChangeIsDone = async () => {
        setDisabled(true);
        await props.onChangeIsDone(item.id, item.isDone ? false : true);
        setDisabled(false);
    }

    return (
        <>
            <Button title="button.view" theme="link primary" onClick={() => context.modal.open(props.viewModalId, item.id)}>
                <FontAwesomeIcon icon={faEye} />
            </Button>
            <If condition={context.userHasRole(Roles.ACCOMMODATION_BOOKINGS_WRITE)}>
                <Button
                    title={item.isDone ? "accommodation.event.markAsUndone" : "accommodation.event.markAsDone"}
                    theme="link primary"
                    // className={item.isDone ? "text-red-500" : "text-green-500"}
                    disabled={disabled}
                    onClick={() => onChangeIsDone()}
                >
                    <FontAwesomeIcon icon={item.isDone ? faTimesSquare : faCheckSquare} />
                </Button>
            </If>
        </>
    );
}

export default EventDatalistActions;
